export const HOW_RENT = {
  Header: 'O que você precisa para alugar?',
  Body: [
    {
      Title: 'Identidade:',
      Paragraphs: [
        `Para poder retirar o veículo, o condutor principal, assim como condutores adicionais deverão apresentar
        habilitação válida para conduzir, com data de emissão mínima de 2 anos.`,
        `Os condutores também poderão apresentar o documento de identidade nos países membros do Mercosul.
        Em destinos internacionais, os condutores deverão apresentar os passaportes válidos.`,
        `Lembre-se que a sua CNH deve ser válida; uma vez que, se este documento tiver a data de validade 
        impressa e for uma data anterior à data em que o serviço é prestado; esta licença não tem qualquer 
        validade internacional, uma vez que será considerada como um documento vencido pelas autoridades do 
        país onde o serviço será tomado, pelo que a empresa de aluguer pode negar a entrega do veículo, uma 
        vez que a licença não é válida. Lembre-se que para alguns países é exigido a permissão internacional.`
      ]
    },
    {
      Title: 'Pré autorização no cartão de crédito:',
      Paragraphs: [
        `O condutor principal deverá apresentar um cartão de crédito emitido em seu nome. O cartão de crédito será
        utilizado como pré autorização para bloqueio de valor específico, conforme locadora e modelo do veículo, que
        será liberado na devolução do veículo.`,
      ]
    },
    {
      Title: 'Restrição de Idade:',
      Paragraphs: [
        'Para condutores com idade inferior a 25 anos ou maior de 65 anos, a tarifa terá um adicional.',
      ]
    },
    {
      Title: 'Detalhe do pagamento:',
      Paragraphs: [
        'Veja aqui os detalhes completos de sua compra.',
      ]
    }
  ]
};
